"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.saveByteArray = exports.confirmMessage = exports.copyTextToClipBoard = exports.copyToClipboard = exports.scrollToTop = exports.useIdleTimer = exports.useSnackbar = exports.withStyles = exports.makeStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.makeStyles = styles_1.makeStyles;
exports.withStyles = styles_1.withStyles;
var notistack_1 = require("notistack");
exports.useSnackbar = notistack_1.useSnackbar;
var idle_timer_1 = __importDefault(require("./idle-timer"));
exports.useIdleTimer = idle_timer_1["default"];
var scroll_to_top_1 = __importDefault(require("./scroll-to-top"));
exports.scrollToTop = scroll_to_top_1["default"];
exports.copyToClipboard = function (e) {
    e.preventDefault();
    var node = e.currentTarget.nextSibling;
    var isChrome = !!window.chrome && !!window.chrome.webstore;
    var selection = window.getSelection();
    if (selection === null || node === null) {
        return;
    }
    var range = document.createRange();
    if (isChrome)
        range.selectNode(node);
    else
        range.selectNodeContents(node);
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand('copy');
    }
    catch (e) {
        console.log(e);
    }
    selection.removeAllRanges();
};
exports.copyTextToClipBoard = function (s) {
    return navigator.clipboard.writeText(s);
};
exports.confirmMessage = function (func, msg, type, anchorOrigin) {
    var duration = type === 'success' || type === 'info' ? 2000 : 4000;
    func(msg, {
        variant: type ? type : 'default',
        autoHideDuration: duration,
        anchorOrigin: anchorOrigin
            ? anchorOrigin
            : { horizontal: 'left', vertical: 'bottom' }
    });
};
exports.saveByteArray = function (fileName, byte, type) {
    if (type === void 0) { type = 'application/text'; }
    var blob = new Blob([byte], { type: type });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    link.click();
};
